module.exports = __webpack_public_path__ + "static/media/team-picture.44847223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-picture.png
// module id = 620
// module chunks = 0